import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getUnlinkCustomerKrossUrl } from "./api-url.constants";
import { UnlinkCustomerKrossError } from "./errors";

export const unlinkCustomerKross = async (customerId: string, userId?: string): Promise<void> => {
  const response = await typedFetch(getUnlinkCustomerKrossUrl(customerId, userId), {
    method: API_METHODS.DELETE,
  });

  if (!response.ok) throw new UnlinkCustomerKrossError();
};
